import React from "react"

import {
  Button,
  Col,
  UncontrolledTooltip
} from "reactstrap";

function TableButton({id, isFree, nbPers, isUPHF, tableChoice}) {

    const tableFormat = (tableName) => {
      return (parseInt(tableName[0], 36) - 10) * 11 + parseInt(tableName.slice(1))
    }

    let items=['A', 'A', 'A', 'A', 'A', 'A', 'A', 'A', 'A', 'A', 'A']
    let buttonsList = items.map((_, index) => {
      if (isUPHF) {
        let id_ = id + index.toString()
        if (id.includes("D") || id.includes("F")) {
          return <Col key={index} style={{margin: "0", padding: "0"}}>
                  {(index < 6 && index > 0) ?
                  <>
                    <Button id={id_} color={(isFree[tableFormat(id_)] <= 10 - nbPers) ? 'success' : 'danger'} disabled={(isFree[tableFormat(id_)] <= 10 - nbPers) ? false : true} style={{padding: "calc(1vw + 1vh - 0.65em)", fontSize: "calc(1vw + 1vh)"}} onClick={(e) => tableChoice(e, id_) }>{id_}</Button>
                    <UncontrolledTooltip target= {`#${id_}`}>
                        Il reste {10 - isFree[tableFormat(id_)]} places à cette table.
                    </UncontrolledTooltip>
                  </>
                  :
                  <>
                    <Button id={index} color={'warning'} disabled={true} style={{padding: "calc(1vw + 1vh - 0.65em)", fontSize: "calc(1vw + 1vh)"}}>----</Button>
                  </>}
                </Col>

        } else {
          return <Col key={index} style={{margin: "0", padding: "0"}}>
                    <Button id={index} color={'warning'} disabled={true} style={{padding: "calc(1vw + 1vh - 0.65em)", fontSize: "calc(1vw + 1vh)"}}>----</Button>
                 </Col>
        }

      } else if (id.includes("E")) {
        let id_ = id + index.toString()
        return <Col key={index} style={{margin: "0", padding: "0"}}>
                {(index > 8) ?
                  <>
                    <Button id={id_} color={(isFree[tableFormat(id_)] <= 10 - nbPers) ? 'success' : 'danger'} disabled={(isFree[tableFormat(id_)] <= 10 - nbPers) ? false : true} style={{padding: "calc(1vw + 1vh - 0.65em)", fontSize: "calc(1vw + 1vh)"}} onClick={(e) => tableChoice(e, id_) }>{id_}</Button>
                    <UncontrolledTooltip target= {`#${id_}`}>
                        Il reste {10 - isFree[tableFormat(id_)]} places à cette table.
                    </UncontrolledTooltip>
                  </>
                  :
                  <>
                  <Button id={index} color={'neutral'} disabled={true} style={{padding: "calc(1vw + 1vh - 0.65em)", fontSize: "calc(1vw + 1vh)"}}>----</Button>
                </>}
               </Col>
               
      } else if (id.includes("D") || id.includes("F")) {
        let id_ = id + index.toString()
        return <Col key={index} style={{margin: "0", padding: "0"}}>
        {!(index < 6 && index > 0) ?
        <>
          <Button id={id_} color={(isFree[tableFormat(id_)] <= 10 - nbPers) ? 'success' : 'danger'} disabled={(isFree[tableFormat(id_)] <= 10 - nbPers) ? false : true} style={{padding: "calc(1vw + 1vh - 0.65em)", fontSize: "calc(1vw + 1vh)"}} onClick={(e) => tableChoice(e, id_) }>{id_}</Button>
          <UncontrolledTooltip target= {`#${id_}`}>
              Il reste {10 - isFree[tableFormat(id_)]} places à cette table.
          </UncontrolledTooltip>
        </>
        :
        <>
          <Button id={index} color={'warning'} disabled={true} style={{padding: "calc(1vw + 1vh - 0.65em)", fontSize: "calc(1vw + 1vh)"}}>----</Button>
        </>}
      </Col>
      } else {
        let id_ = id + index.toString()
        return <Col key={index} style={{margin: "0", padding: "0"}}>
                <Button id={id_} color={(isFree[tableFormat(id_)] <= 10 - nbPers) ? 'success' : 'danger'} disabled={(isFree[tableFormat(id_)] <= 10 - nbPers) ? false : true} style={{padding: "calc(1vw + 1vh - 0.65em)", fontSize: "calc(1vw + 1vh)"}} onClick={(e) => tableChoice(e, id_) }>{id_}</Button>
                <UncontrolledTooltip target= {`#${id_}`}>
                    Il reste {10 - isFree[tableFormat(id_)]} places à cette table.
                </UncontrolledTooltip>
               </Col>
      }
  })

  return (
    <>  
        {buttonsList}
    </>
  );
}

export default TableButton;
